import { RefinementList } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';

import { useSearchDictionary } from '../util';

const ClassificationFacet = () => {
  const dict = useSearchDictionary();

  return (
    <div className={classnames('mb-4')}>
      <div className={classnames('text-blue-navy', 'heading-sm', 'mb-6')}>
        {dict.classification}
      </div>
      <RefinementList attribute="classification" sortBy={['name:asc']} />
    </div>
  );
};

export default ClassificationFacet;
